import { axiosInstance } from '../App';

export function getSiteLogo() {
    return axiosInstance.get('/api/public/site/getImage', { responseType: 'blob' })
        .then(response => URL.createObjectURL(response.data))
        .catch(error => {
            console.error("Error fetching the logo image:", error);
            throw error;
        });
}

export function getSiteConsent() {
    return axiosInstance.get('/api/public/site/getConsent', { responseType: 'text' })
    .then(response => response.data)
    .catch(error => {
        console.error("Error fetching the consent:", error);
        throw error;
    });
}

export function acceptConsent() {
    console.log("Accepting the consent");
    return axiosInstance.post('/api/secured/site/acceptConsent')
    .then(response => response.data)
    .catch(error => {
        console.error("Error accepting the consent:", error);
        throw error;
    });
}